export enum SituacaoReservaAulaEnum {
  Reservado,
  Cancelado,
  Confirmado,
}
